import { Category } from "./category";
import { Publication } from "./publication";

export class BasicMetaData {
    public __classname__: string = 'BasicMetaData';

    public ID : string | null = null;

    public DocumentID : string | null = null;

    public Name : string | null = null;

    public Type : string | null = null;

    public Publication : Publication | null = null;

    public Category : Category | null = null;

    public ContentSource : string | null = null;

    public MasterId : string | null = null;

    public StoryId : string | null = null;

    constructor(
        params : BasicMetaDataNamedParameters
    ) {
        this.ID = params.ID ?? null;
        this.DocumentID = params.DocumentID ?? null;
        this.Name = params.Name ?? null;
        this.Type = params.Type ?? null;
        this.Publication = params.Publication ?? null;
        this.Category = params.Category ?? null;
        this.ContentSource = params.ContentSource ?? null;
        this.MasterId = params.MasterId ?? null;
        this.StoryId = params.StoryId ?? null;
    }
}

export interface BasicMetaDataNamedParameters {
    ID? : string 
    DocumentID? : string
    Name? : string 
    Type? : string  
    Publication? : Publication 
    Category? : Category 
    ContentSource? : string 
    MasterId? : string 
    StoryId? : string 
}